import SvgApi from '@assets/svg/API.svg';
import SvgBilling from '@assets/svg/Billing.svg';
import SvgCapacity from '@assets/svg/Capacity.svg';
import SvgDashboard from '@assets/svg/Dashboard.svg';
import SvgNumbers from '@assets/svg/Numbers.svg';
import SvgOrder from '@assets/svg/Order.svg';
import SvgPorting from '@assets/svg/Porting.svg';
import SvgProduct from '@assets/svg/Product.svg';
import SvgProfiles from '@assets/svg/Profiles.svg';
import SvgReports from '@assets/svg/Reports.svg';
import SvgSettings from '@assets/svg/Settings.svg';
import SvgTickets from '@assets/svg/Tickets.svg';

export const IconApi = ({ className }) => <SvgApi className={className} />;
export const IconBilling = ({ className }) => (
  <SvgBilling className={className} />
);
export const IconCapacity = ({ className }) => (
  <SvgCapacity className={className} />
);
export const IconDashboard = ({ className }) => (
  <SvgDashboard className={className} />
);
export const IconNumbers = ({ className }) => (
  <SvgNumbers className={className} />
);
export const IconOrder = ({ className }) => <SvgOrder className={className} />;
export const IconPorting = ({ className }) => (
  <SvgPorting className={className} />
);
export const IconProduct = ({ className }) => (
  <SvgProduct className={className} />
);
export const IconReports = ({ className }) => (
  <SvgReports className={className} />
);
export const IconProfiles = ({ className }) => (
  <SvgProfiles className={className} />
);
export const IconSettings = ({ className }) => (
  <SvgSettings className={className} />
);
export const IconTickets = ({ className }) => (
  <SvgTickets className={className} />
);
